import { Row, Spin, Typography } from 'antd';

const { Title } = Typography;

export function StepTwo() {
    return (
        <Row className='flex-col items-center'>
            <Title className='w-full text-center' level={3}>
                <div>Processando arquivos, por favor aguarde.</div>
                <div>Caso sair desta página ou fecha-lá, as informações serão perdidas.</div>
            </Title>
            <Spin />
        </Row>
    );
}
